/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_New_Err_Source_LotInputs */

const vi_pll_new_err_source_lot = /** @type {(inputs: Pll_New_Err_Source_LotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn lô lấy hương nguồn`)
};

/**

* @param {Pll_New_Err_Source_LotInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_new_err_source_lot = /** @type {((inputs?: Pll_New_Err_Source_LotInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_New_Err_Source_LotInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_new_err_source_lot(inputs)
});